import { useCallback, useEffect } from "react";

import { PositiveAction } from "../../components/card/PositiveAction";
import { PauseGardenerFormContext, pauseGardenerFormHasChanged, scrollToFirstError, usePauseGardenerForm, validatePauseGardenerForm } from "./PauseGardenerDialog";

interface SubmitButtonProps {
    onSubmit: (form: PauseGardenerFormContext) => void;
}

export const SubmitButton = (props: SubmitButtonProps) => {
    const { onSubmit } = props;

    const { form, setForm } = usePauseGardenerForm();    

    const hasChanged = pauseGardenerFormHasChanged(form);

    const { validationAnimationDuration } = form;
    useEffect(() => {
        if ( validationAnimationDuration === 200 ) return;

        setForm((previousState): PauseGardenerFormContext => ({
            ...previousState,
            validationAnimationDuration: 200,
        }))
    }, [setForm, validationAnimationDuration]);

    const skipValidationAnimation = useCallback(() => {
        setForm((previousState): PauseGardenerFormContext => ({
            ...previousState,
            validationAnimationDuration: 0,
        }));
    }, [setForm]);

    const submit = useCallback(() => {
        const anyError = validatePauseGardenerForm(form);
        if ( anyError ) {
            skipValidationAnimation();
            setForm((previousState): PauseGardenerFormContext => ({
                ...previousState,
                reasonInput: {
                    ...previousState.reasonInput,
                    dirty: true,
                },
            }));
            return scrollToFirstError(form);
        }

        onSubmit(form);
    }, [setForm, skipValidationAnimation, onSubmit, form]);

    return (
        <PositiveAction onClick={submit} disabled={!hasChanged}>Ja, sæt på pause</PositiveAction>
    );
};
